/* tslint:disable */
/* eslint-disable */
/**
 * Lemonway DirectKit API 2.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EuPagoInit } from './EuPagoInit';
import {
    EuPagoInitFromJSON,
    EuPagoInitFromJSONTyped,
    EuPagoInitToJSON,
} from './EuPagoInit';

/**
 * 
 * @export
 * @interface MoneyInMultibancoInitOutput
 */
export interface MoneyInMultibancoInitOutput {
    /**
     * 
     * @type {EuPagoInit}
     * @memberof MoneyInMultibancoInitOutput
     */
    euPagoInit?: EuPagoInit;
    /**
     * 
     * @type {Error}
     * @memberof MoneyInMultibancoInitOutput
     */
    error?: Error;
}

/**
 * Check if a given object implements the MoneyInMultibancoInitOutput interface.
 */
export function instanceOfMoneyInMultibancoInitOutput(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MoneyInMultibancoInitOutputFromJSON(json: any): MoneyInMultibancoInitOutput {
    return MoneyInMultibancoInitOutputFromJSONTyped(json, false);
}

export function MoneyInMultibancoInitOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): MoneyInMultibancoInitOutput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'euPagoInit': !exists(json, 'euPagoInit') ? undefined : EuPagoInitFromJSON(json['euPagoInit']),
        'error': !exists(json, 'error') ? undefined : json['error'],
    };
}

export function MoneyInMultibancoInitOutputToJSON(value?: MoneyInMultibancoInitOutput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'euPagoInit': EuPagoInitToJSON(value.euPagoInit),
        'error': value.error,
    };
}

